import React from 'react';
import { ConnectedSegmentManagerRoundTrip } from './SegmentManagerRoundTripMobile';
import { ConnectedSegmentManagerDefault } from './SegmentManagerDefaultMobile';
import { ConnectedSegmentManager } from './SegmentManager';

export const SegmentManagerMobile = () => (
    <ConnectedSegmentManager render={
        (isRoundTrip) => isRoundTrip ? <ConnectedSegmentManagerRoundTrip /> : <ConnectedSegmentManagerDefault />
    }
    />
);
